import { Button } from "@mui/material";

interface Props {
	onClick: () => void;
	disabled?: boolean;
}

export const ExcelButton = ({ onClick, disabled }: Props) => {
	return (
		<Button
			fullWidth
			variant="outlined"
			disabled={disabled}
			onClick={onClick}
			startIcon={<i className="far fa-file-excel"></i>}
			style={{
				width: "auto",
				height: 35,
				display: "flex",
				justifyContent: "space-between",
				padding: "0 14px",
				fontSize: 14,
				color: `${disabled ? "grey" : "#217346"}`,
				border: `1px solid ${disabled ? "grey" : "#217346"}`,
				backgroundColor: "#fff",
			}}
		>
			EXPORT TO EXCEL
		</Button>
	);
};
